export default function SavedSearchService($http, appSettings, $q) {
  'ngInject';
  var savedSearches = {};
  var savedSearchEndpoint = appSettings.InReachApiSavedSearchEndpoint;

  /**
      Retrieves all saved searches for the current user
  */
  savedSearches.getSearches = function () {

    var def = $q.defer();

    var savedSearchResult = {
      data: [{
        name: 'Nelson\'s saved search',
        description: 'Very good, lots of security groups.',
        securityGroups: [
          '19283712309',
          '40192381233',
          '12329833123'
        ],
        alertStates: [
          'low',
          'medium'
        ],
        maintenanceStates: [
          'overdue',
          'upcoming'
        ],
        attrs: [{
            'id': '519418005948745116',
            'values': [
              'Nate Dogg',
              'Doggy Dogg'
            ]
          },
          {
            'id': '519418005948745116',
            'values': [
              '3.0'
            ]
          },
          {
            'id': '519418005948745116',
            'values': [
              '3.0'
            ],
            'range': {
              'max': '90/1920/1029',
              'min': '90/1920/1029'
            }
          }
        ]
      }],
      included: [

      ],
      meta: {
        'total-pages': 10
      },
      links: {
        'self': 'https://onei3.com/api/savedsearches/',
        'next': 'https://onei3.com/api/savedsearches?page[offset]=2',
        'last': 'https://onei3.com/api/savedsearches?page[offset]=10'
      }
    };

    def.resolve(savedSearchResult);
    return def.promise;
  };

  /**
      Saves a new search in the API database
  */
  savedSearches.saveSearch = function (search) {
    return $http.post(savedSearchEndpoint + '/saved', search);
  };
  /**
         Deletes an existing search in the API database
     */
  savedSearches.deleteSearch = function (savedSearchID) {
    return $http.delete(savedSearchEndpoint + '/saved/delete/' + savedSearchID);
  };

  return savedSearches;
}